import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';

import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonAppModule as LocalCommonAppModule } from '../common-app/common-app.module';
import { CommonOperationsModule } from '../common-operations/common-operations.module';
import { DeviceModule } from '../device/device.module';
import { DocumentModule } from '../document/document.module';
import { OrderModule } from '../order/order.module';
import { BoxContentDetailComponent } from './box-content-detail/box-content-detail.component';
import { BoxContentTableComponent } from './box-content-table/box-content-table.component';
import { ContainerCounterStatsComponent } from './container-counter-stats/container-counter-stats.component';
import { ContainerStatsComponent } from './container-stats/container-stats.component';
import { InstructionDialogComponent } from './instruction-dialog/instruction-dialog.component';
import { OrderTableComponent } from './order-table/order-table.component';
import { PackageInstructionsComponent } from './package-instructions/package-instructions.component';
import { PackageOrderComponent } from './package-order/package-order.component';
import { PackageRoutingModule } from './package-routing.module';
import { SelectBoxComponent } from './select-box/select-box.component';
import { BoxModelApiService } from './services/box-model-api.service';
import { BoxModelCacheService } from './services/box-model-cache.service';
import { BoxModelService } from './services/box-model.service';
import { OrderLinePackedVoService } from './services/order-line-packed-vo.service';
import { PackageOrderCacheService } from './services/package-order-cache.service';
import { PackageOrderService } from './services/package-order.service';
import { SortOrderLinePackedVoPipe } from './sort-order-line-packed-vo.pipe';
import { WeightDialogComponent } from './weight-dialog/weight-dialog.component';
import { CommonAppModule } from 'common';

@NgModule({
  declarations: [
    PackageInstructionsComponent,
    PackageOrderComponent,
    OrderTableComponent,
    SelectBoxComponent,
    BoxContentTableComponent,
    BoxContentDetailComponent,
    ContainerStatsComponent,
    WeightDialogComponent,
    ContainerCounterStatsComponent,
    SortOrderLinePackedVoPipe,
    InstructionDialogComponent
  ],
  exports: [
    OrderTableComponent,
    ContainerStatsComponent,
    ContainerCounterStatsComponent
  ],
  imports: [
    CommonModule,
    LocalCommonAppModule,
    CommonAppModule,
    FormsModule,
    PackageRoutingModule,
    OrderModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    CommonOperationsModule,
    MatSnackBarModule,
    MatGridListModule,
    MatListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatChipsModule,
    MatToolbarModule,
    NgxSpinnerModule,
    MatExpansionModule,
    MatTooltipModule,
    QRCodeModule,
    DeviceModule,
    DocumentModule
  ],
  providers: []
})
export class PackageModule {
  static forRoot(): ModuleWithProviders<PackageModule> {
    return {
      ngModule: PackageModule,
      providers: [
        BoxModelApiService,
        { provide: BoxModelService, useClass: BoxModelCacheService },
        { provide: PackageOrderService, useClass: PackageOrderCacheService },
        OrderLinePackedVoService
      ]
    };
  }
}
